module.exports = __webpack_public_path__ + "static/media/nbwf.db382d06.jpeg";